import { Train, Route, Landmark, Construction, Mountain, Building2 } from "lucide-react";
import { Reveal, Eyebrow } from "./primitives";

const services = [
    {
        icon: Train,
        title: "Railway Civil Works",
        desc: "Complete railway civil execution — track works, station buildings, platforms, yards and allied structures built to railway authority specifications.",
        span: "md:col-span-2 md:row-span-2",
        tall: true,
    },
    {
        icon: Route,
        title: "Track Laying & Linking",
        desc: "New track, doubling, siding and turnout works with precise line, level and geometry control.",
        span: "",
    },
    {
        icon: Landmark,
        title: "Platform & Station Works",
        desc: "Platform construction, shelter structures, foot-over-bridges and station finishing works.",
        span: "",
    },
    {
        icon: Construction,
        title: "Bridges, RUBs & ROBs",
        desc: "Minor and major bridges, road-under-bridges and road-over-bridges — substructure to completion.",
        span: "",
    },
    {
        icon: Mountain,
        title: "Earthwork & Embankments",
        desc: "Formation, embankment, cutting and land development with compaction to spec.",
        span: "",
    },
    {
        icon: Building2,
        title: "General Infrastructure",
        desc: "Roads, industrial sheds, boundary and drainage works, and civil infrastructure for public and private clients.",
        span: "",
    },
];

export default function Services() {
    return (
        <section id="services" data-testid="services-section" className="border-b border-navy-line bg-white">
            <div className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 lg:py-32">
                <div className="mb-14 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
                    <div>
                        <Reveal>
                            <Eyebrow>What We Build</Eyebrow>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <h2 className="mt-6 font-display text-5xl font-semibold uppercase leading-[0.95] tracking-mega text-navy md:text-6xl">
                                Services
                            </h2>
                        </Reveal>
                    </div>
                    <Reveal delay={0.2}>
                        <p className="max-w-sm text-base leading-relaxed text-ink/60">
                            Two disciplines, one standard — railway civil works and general
                            infrastructure, executed end to end by our own teams.
                        </p>
                    </Reveal>
                </div>

                <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                    {services.map((s, i) => (
                        <Reveal key={s.title} delay={i * 0.06} className={s.span}>
                            <div
                                data-testid={`service-card-${i}`}
                                className={`group flex h-full flex-col justify-between border border-navy-line p-7 transition-colors duration-300 hover:border-navy hover:bg-navy ${
                                    s.tall ? "min-h-[280px] bg-navy text-white" : "min-h-[190px] bg-paper"
                                }`}
                            >
                                <s.icon
                                    className={`h-8 w-8 ${s.tall ? "text-orange" : "text-navy group-hover:text-orange"} transition-colors duration-300`}
                                    strokeWidth={1.5}
                                />
                                <div className={s.tall ? "mt-16" : "mt-10"}>
                                    <h3
                                        className={`font-display text-xl font-semibold uppercase tracking-[0.02em] ${
                                            s.tall ? "text-white md:text-2xl" : "text-navy"
                                        }`}
                                    >
                                        {s.title}
                                    </h3>
                                    <p
                                        className={`mt-3 text-sm leading-relaxed ${
                                            s.tall ? "text-white/70" : "text-ink/60"
                                        }`}
                                    >
                                        {s.desc}
                                    </p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
